export default __webpack_public_path__ + "images/NP.5a527e5.png";